export const shapes = {
    CIRCLE: 'CIRCLE',
    SQUARE: 'SQUARE',
};
export const selectionTypes = {
    multiple: 'multiple',
    single: 'single',
};
export const optionType = {
    checkbox: 'checkbox',
    radio: 'radio',
};
export const layouts = {
    custom: 'custom',
    scroll: 'scroll',
    stack: 'stack',
};
export const optionTypes = {
    [selectionTypes.multiple]: optionType.checkbox,
    [selectionTypes.single]: optionType.radio,
};
export const sizes = {
    large: 'large',
    medium: 'medium',
    small: 'small',
    xsmall: 'xsmall',
};
export const swatchDiameters = {
    [sizes.large]: 48,
    [sizes.medium]: 32,
    [sizes.small]: 24,
    [sizes.xsmall]: 16,
};
export const swatchBorderWidth = 1;
export const selectedSwatchBorderWidth = 2;
export const swatchPadding = 4;
export const extraSmallSwatchBorderWidth = 1;
export const extraSmallSwatchPadding = 1;
